export default "__VITE_ASSET__BfuflP6k__"